import React, { useState, useEffect } from 'react';
import StatsCards from '../../../../components/Admin/Dasboard/StatsCards/StatsCards';
import RevenueChart from '../../../../components/Admin/Dasboard/RevenueChart/RevenueChart';
import TopProducts from '../../../../components/Admin/Dasboard/TopProducts/TopProducts';
import RecentOrders from '../../../../components/Admin/Dasboard/RecentOrders/RecentOrders';
import AiFeature from '../../../../components/Admin/Dasboard/AiFeature/AiFeature';
import SalesPurchases from '../../../../components/Admin/Dasboard/SalesPurchases/SalesPurchases';
import Devices from '../../../../components/Admin/Dasboard/Devices/Devices';
import '../../../../assests/css/admin/Dashboard.css';

const Dashboard = () => {
  const [dateRange, setDateRange] = useState('Last 30 Days');
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className={`AdminSideDashboard ${isLoaded ? 'AdminSideDashboard--loaded' : ''}`}>
      <div className="AdminSideDashboard__header AdminSideDashboard--fadeIn">
        <div>
          <h1 className="AdminSideDashboard__title">Dashboard Overview</h1>
          <p className="AdminSideDashboard__subtitle">
            Welcome back, here's what's happening with your store today.
          </p>
        </div>
        <div className="AdminSideDashboard__dateSelector">
          <select 
            value={dateRange} 
            onChange={(e) => setDateRange(e.target.value)}
            className="AdminSideDashboard__select"
          >
            <option>Last 7 Days</option>
            <option>Last 30 Days</option>
            <option>Last 90 Days</option>
            <option>Last Year</option>
          </select>
        </div>
      </div>

      <StatsCards dateRange={dateRange} />

      {/* Sales & Purchases and Devices Charts Section */}
      {/* <div className="AdminSideDashboard__chartsGrid">
        <SalesPurchases />
        <Devices />
      </div> */}

      <div className="AdminSideDashboard__contentGrid">
        <RevenueChart />
        <TopProducts />
      </div>

      {/* <AiFeature /> */}
      <RecentOrders />
    </div>
  );
};

export default Dashboard;